import { render, staticRenderFns } from "./DeliveryAttachmentShower.vue?vue&type=template&id=7c2c847b&"
import script from "./DeliveryAttachmentShower.vue?vue&type=script&lang=js&"
export * from "./DeliveryAttachmentShower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports